import { currencies, Currency } from '~/constants/currency';
import * as moment from 'moment';
import * as APIMessage from '~/types/APIMessage';
import { JSONParcel, Parcel, parcelFromJSON } from '~/types/OrdersBatch';
import Rate, * as rates from '~/types/Rate';

enum ShipmentStatus {
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  COMPLETE = 'COMPLETE',
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS',
}

export type ShipmentObjectId = string;

type JSONShipment = {
  object_id: string;
  rates: rates.JSONRate[];
  parcels: JSONParcel[];
  messages: APIMessage.JSONAPIMessage[];
  status: string;
  shipment_date: string;
  extra: JSONShipmentExtra;
};

type JSONShipmentExtra = {
  insurance?: {
    amount: string;
    currency: string;
  };
  signature_confirmation?: string;
};

// Complete it later
type Shipment = {
  objectId: ShipmentObjectId;
  rates: Rate[];
  parcels: Parcel[];
  messages: APIMessage.APIMessage[];
  status: ShipmentStatus;
  shipmentDate: moment.Moment;
  extra?: ShipmentExtra;
};

type ShipmentExtra = {
  insurance?: {
    amount: string;
    currency: Currency;
  };
  signatureConfirmation?: string;
};

function fromJSON(jsonShipment: JSONShipment): Shipment {
  return {
    objectId: jsonShipment.object_id,
    rates: jsonShipment.rates.map(rates.fromJSON),
    parcels: jsonShipment.parcels.map(parcelFromJSON),
    messages: jsonShipment.messages.map(APIMessage.fromJSON),
    status: ShipmentStatus[jsonShipment.status],
    shipmentDate: moment(jsonShipment.shipment_date),
    extra: extraFromJSON(jsonShipment.extra),
  };
}

function extraFromJSON(jsonExtra?: JSONShipmentExtra) {
  if (!jsonExtra) return;

  const extra: ShipmentExtra = {
    signatureConfirmation: jsonExtra.signature_confirmation,
  };

  if (jsonExtra.insurance) {
    extra.insurance = {
      amount: jsonExtra.insurance.amount,
      currency: currencies[jsonExtra.insurance.currency],
    };
  }

  return extra;
}

function isShipmentCompleted(status: ShipmentStatus) {
  return new Set([ShipmentStatus.COMPLETE, ShipmentStatus.ERROR, ShipmentStatus.SUCCESS]).has(
    status,
  );
}

export default Shipment;

export { JSONShipment, ShipmentStatus, isShipmentCompleted, fromJSON };
